import { useEffect, useState } from "react";

function isHubOverlayOpen() {
  if (typeof document === "undefined") return false;
  return Boolean(
    document.querySelector(
      "[data-hub-overlay='1'], [data-hub-overlay-body='1'], [class*='hubSheetBackdrop'], [class*='hubDialogBackdrop'], [class*='venuesHubModalBackdrop']",
    ),
  );
}

/** True when a hub sheet or desktop dialog is open (activation should stay out of the way). */
export function useOverlayOpen() {
  const [open, setOpen] = useState(isHubOverlayOpen);

  useEffect(() => {
    const check = () => setOpen(isHubOverlayOpen());
    check();
    const obs = new MutationObserver(check);
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "data-hub-overlay", "data-hub-overlay-body"],
    });
    return () => obs.disconnect();
  }, []);

  return open;
}
